import { Injectable, inject } from "@angular/core";
import type { Guid } from "@kiraah-shared/common";
import { Observable } from "rxjs";
import type {
  IMobileVoiceTicketDemand,
  IMobileVoiceTicketGenerateResult,
} from "../models/mobile-voice-ticket.models";
import { MobileVoiceTicketApiClient } from "./mobile-voice-ticket-api.client";

@Injectable({ providedIn: "root" })
export class MobileVoiceTicketService {
  private readonly api = inject(MobileVoiceTicketApiClient);

  submitTranscript(rawText: string, demandUid?: Guid | null): Observable<IMobileVoiceTicketDemand> {
    return this.api.submitTranscript({
      RawText: rawText,
      DemandUid: demandUid ?? undefined,
    });
  }

  getActiveDraft(): Observable<IMobileVoiceTicketDemand> {
    return this.api.getActiveDraft();
  }

  generateDraft(demandUid: Guid): Observable<IMobileVoiceTicketGenerateResult> {
    return this.api.generateDraft(demandUid);
  }
}
